import { TranslatedText } from '../Translation';

export interface FilterValue {
  id: number;
  slug: string;
  title: string;
  titleTranslation: TranslatedText;
}

export const getEmptyFilterValue = (): FilterValue => ({
  id: 0,
  slug: '',
  title: '',
  titleTranslation: {},
});

export const filterValueFromResponse = (responseData: any): FilterValue => ({
  id: responseData.id,
  slug: responseData.slug,
  title: responseData.title,
  titleTranslation: responseData.title_translation ?? {},
});

export const filterValueToUpsertRequest = (filterValue: FilterValue) => ({
  title: filterValue.title,
  title_translation: filterValue.titleTranslation,
});
